export default __webpack_public_path__ + "static/media/noon.082e69ed.svg";